module.exports = __webpack_public_path__ + "img/Immigration.03fbe103.svg";